export default "__VITE_ASSET__CNSwhwwT__"